import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden bg-tactical-950 bg-noise" data-id="element-30">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-31">
        <div className="absolute inset-0 bg-gradient-to-b from-tactical-950/80 via-tactical-950/60 to-tactical-950 z-10" data-id="element-32" />
        <div className="absolute inset-0 bg-gradient-to-r from-tactical-950 via-transparent to-tactical-950 z-10" data-id="element-33" />
        <img src="https://cdn.magicpatterns.com/uploads/jdc6HTjXBhyBcsrrdAQVpY/sentinel_3.png" alt="Urban tactical compass in the rain" className="w-full h-full object-cover object-center opacity-40 mix-blend-luminosity" data-id="element-34" />
        {/* Scan line effect */}
        <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(0,0,0,0.25)_50%)] bg-[length:100%_4px] z-20 pointer-events-none opacity-20" data-id="element-35" />
      </div>

      <div className="relative z-30 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="space-y-8" data-id="element-37">
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white uppercase tracking-tight leading-tight" data-id="element-38">
            ¿Qué harías si el sistema que protege a tu familia{' '}
            <span className="text-cyan-accent text-glow-cyan" data-id="element-39">"parpadea"</span>{' '}
            mañana?
          </h1>

          <div className="w-24 h-1 bg-cyan-accent mx-auto shadow-[0_0_10px_rgba(0,212,255,0.5)]" data-id="element-40" />

          <p className="text-xl md:text-2xl text-gray-200 font-medium max-w-4xl mx-auto leading-relaxed" data-id="element-41">
            Cómo Blindar tu Apartamento, Proteger tus Ahorros y Dominar el Caos
            Urbano en Menos de 14 Días... Sin Tener un Búnker, Sin Vivir en el
            Bosque y Sin Parecer un "Prepper" Loco.
          </p>

          <div className="p-6 bg-tactical-900/60 backdrop-blur-sm border border-tactical-800 rounded-lg max-w-3xl mx-auto mt-8 shadow-2xl" data-id="element-42">
            <p className="text-lg text-gray-400 leading-relaxed" data-id="element-43">
              Un Protocolo de Resiliencia 360° diseñado para profesionales
              urbanos que saben que el 2026 no será un año normal, pero se
              niegan a ser víctimas de la próxima crisis climática o financiera.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}